import React, { useState, useEffect, useRef } from "react";
import HeaderTwo from "../components/header2";
import styles from "../styles/register.module.css";
import { ReactComponent as ChevronRight } from '../svg/chevron-right-solid-black.svg';
import { ReactComponent as ChevronLeft } from '../svg/chevron-left-solid-black.svg';
import { Button } from "@mui/material";
import Footer from "../components/footer";
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from "react-router-dom";
import SpeedDialComponent from "../control/speeddial";
import { useMediaQuery } from "react-responsive";
import ReactGa from "react-ga4";
import { each, set } from "lodash";
import { start } from "repl";


// const startDate = new Date();




const weeks = [1, 2, 3, 4, 5, 6];
var intervalId: any;

const weekString = ["일", "월", "화", "수", "목", "금", "토"];


const RegisterFor2026Winter: React.FC<any> = (props) => {

    const [preWinterData, setPreWinterData] = useState([
        {
            dateString: "2025.12.31",
            year: 2025,
            month: 12,
            date: 31,
            discount: false,
            price: 0,
            afterPrice: 0
        },
        {
            dateString: "2026.01.31",
            year: 2026,
            month: 1,
            date: 31,
            discount: false,
            price: 0,
            afterPrice: 0
        },
        {
            dateString: "2026.02.28",
            year: 2026,
            month: 2,
            date: 28,
            discount: false,
            price: 0,
            afterPrice: 0
        }
    ]);



    const [regularWinterData, setRegularWinterData] = useState(
        [
            {
                dateString: "2026.01.31",
                year: 2026,
                month: 1,
                date: 31,
                discount: false,
                price: 942900,
                afterPrice: 895000
            },
            {
                dateString: "2026.02.28",
                year: 2026,
                month: 2,
                date: 28,
                discount: false,
                price: 1732900,
                afterPrice: 1646200
            }
        ]
    )

    const price = {
        gangnam: "790,000원/월",
        daechi: "790,000원/월",
        bundang: "790,000원/월",
        songpa: "790,000원/월",
        gimpo: "690,000원/월",
        sinchon: "790,000원/월",
        default: "미정"
    }


    // const startDueDateValue = new Date(2025, 10, 17);
    const [startDueDateValue, setStartDueDateValue] = useState(new Date(2025, 10, 17));

    const today = new Date();
    const todayFirstTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
    const todayLastTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
    const currentTime = today.getHours() * 60 + today.getMinutes();

    // const realStartDate = startDueDateValue.getTime() < new Date().getTime() ? new Date() : startDueDateValue;
    const [realStartDate, setRealStartDate] = useState(
        startDueDateValue.getTime() < new Date().getTime() ? new Date() : startDueDateValue
    );
    const realEndDate = new Date(2025, 11, 24);

    const [location, setLocation] = useState("gangnam");

    const [select, setSelect] = useState(0);
    const [dateValue, setDateValue] = useState();
    const startDueDate = startDueDateValue.getTime();
    const [startDate, setStartDate] = useState(
        new Date().getTime() < startDueDate ? startDueDateValue : new Date().getDay() === 0 ? new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1) : new Date()
    );
    const [showingDate, setShowingDate] = useState(
        startDate.getTime() < startDueDate ? startDueDate : startDate.getTime()
    );
    const [month, setMonth] = useState<any>();
    const [year, setYear] = useState<any>();
    const [calendar, setCalendar] = useState<any>();
    const [selectedDay, setSelectedDay] = useState(startDate.getFullYear() * 10000 + startDate.getMonth() * 100 + startDate.getDate());
    const [realSelectedDay, setRealSelectedDay] = useState({ year: startDate.getFullYear(), month: startDate.getMonth(), date: startDate.getDate(), day: startDate.getDay() });
    const [selectedTime, setSelectedTime] = useState(0);

    const [minusMonthDisable, setMinusMonthDisable] = useState(true);

    const [name, setName] = useState("");

    const [fullTelephone, setFullTelephone] = useState(false);
    const [telephoneNumber, setTelephoneNumber] = useState("");
    const [isToday, setIsToday] = useState(true);

    const [timeData, setTimeData] = useState<any>();
    const [loading, setLoading] = useState(false);

    const [isAmRemain, setIsAmRemain] = useState(true);
    const [isPmRemain, setIsPmRemain] = useState(true);

    //클릭 안된 상태, 클릭 한 상태
    const [certifyClicked, setCertifyClicked] = useState<boolean>(false);
    const [remainTime, setRemainTime] = useState(0);
    const [certifyCorrect, setCertifyCorrect] = useState<any>(null);
    const [certNumber, setCertNumber] = useState();


    const telephoneNumberInputRef = useRef<any>(null);
    const certNumberInputRef = useRef<any>(null);

    const [submitStatus, setSubmitStatus] = useState("");

    const [calendarShow, setCalendarShow] = useState(true);
    const [endDateShow, setEndDateShow] = useState(true);

    const [pageNumber, setPageNumber] = useState(1);

    const navigate = useNavigate();


    const eachRef = useRef<any>(new Array());

    //가로 세로 길이 같게 만드는-----------------------------------------
    const isMobile = useMediaQuery({ query: '(max-width : 500px)' });

    const [selectedEndIndex, setSelectedEndIndex] = useState("");

    const [disabled2, setDisabled2] = useState(true);

    const [isConstructionDay, setIsConstructionDay] = useState(false);

    const footerRef = useRef<any>(null);

    const [finalPrice, setFinalPrice] = useState<any>({
        discount: false,
        price: 0,
        finalPrice: 0
    });

    const [bannerVisible, setBannerVisible] = useState(true);

    const [submitLoading, setSubmitLoading] = useState(false);

    const intersect = (entries: any, observer: any) => {

        console.log(entries[0]);
        if (entries[0].isIntersecting) {
            setBannerVisible(false);
        } else {
            setBannerVisible(true);
        }

    }


    useEffect(() => {

        let observer = new IntersectionObserver(intersect, {
            rootMargin: "0px",
            threshold: 0.4
        });

        observer.observe(footerRef.current);

    }, []);

    useEffect(() => {

        console.log("startDate useeffect");
        console.log(startDate);

    }, [startDate]);


    useEffect(() => {

        // setCalendarShow(false);
        console.log("startDate")
        console.log(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());

        if (select === 0) {
            //startDate로 selectedDay, realSelectedDay 설정
            // setCalendarShow(true);


            if (realSelectedDay.month === 11) {
                console.log("startgogogo");
                //2025, 11, 1로 고정
                // setSelectedDay(20251101);
                // setRealSelectedDay({ year: 2025, month: 11, date: 1, day: 1 });

                //오늘로 고정
                const today = new Date();
                setSelectedDay(today.getFullYear() * 10000 + today.getMonth() * 100 + today.getDate());


                return;
            }



            console.log(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());

            setSelectedDay(startDate.getFullYear() * 10000 + startDate.getMonth() * 100 + startDate.getDate());
            setRealSelectedDay({ year: startDate.getFullYear(), month: startDate.getMonth(), date: startDate.getDate(), day: startDate.getDay() });
        }

        if (select === 1) {
            //2025.12.26일로 selectedDay, realSelectedDay 설정
            setSelectedDay(20251126);
            setRealSelectedDay({ year: 2025, month: 11, date: 26, day: 5 });
        }

    }, [select]);

    useEffect(() => {

        if (select === 1) {
            return;
        }


        // if (location === "daechi") 

        if (realSelectedDay.month === 11 || realSelectedDay.month === 0) {
            console.log("startgogogo!!!!!!!");
            console.log(select);
            //2025, 11, 1로 고정
            // setSelectedDay(20251101);
            // setRealSelectedDay({ year: 2025, month: 11, date: 1, day: 1 });
            //오늘로 고정
            const today = new Date();
            setSelectedDay(today.getFullYear() * 10000 + today.getMonth() * 100 + today.getDate());
            setRealSelectedDay({ year: today.getFullYear(), month: today.getMonth(), date: today.getDate(), day: today.getDay() });


            return;
        }

        // }

    }, [location]);


    //ga event------------------------------------------------
    useEffect(() => {

        ReactGa.send({
            hitType: "pageview",
            page_title: "register"
        });

    }, []);
    //--------------------------------------------------------

    useEffect(() => {

    }, [])


    useEffect(() => {

        return;

        setTimeout(() => {

            if (isMobile) {
                if (eachRef.current && eachRef.current.length > 0 && eachRef.current[0]) {
                    const height = eachRef.current[0].clientWidth;
                    eachRef.current.forEach((each: any) => {
                        if (each) {
                            each.style.height = `${height}px`;
                        }
                    })
                }
            }

        }, 100)

    }, [calendar]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pageNumber])


    //달력 만드는기능----------------------------------------------

    useEffect(() => {


        console.log("change");
        const month = new Date(showingDate).getMonth();
        const year = new Date(showingDate).getFullYear();

        console.log(month, year);

        setMonth(month);
        setYear(year);

        if (month === 10 && year === today.getFullYear()) {
            setMinusMonthDisable(true);
        } else {
            setMinusMonthDisable(false);
        }

        const firstDate = new Date(year, month, 1);
        const firstDateDay = firstDate.getDay();
        firstDate.setDate(firstDate.getDate() - firstDateDay);

        const lastDate = new Date(year, month + 1, 0);
        const lastDateDay = lastDate.getDay();
        lastDate.setDate(lastDate.getDate() + (6 - lastDateDay));

        console.log(firstDate.getDate());
        console.log(lastDate.getDate());

        const calendarData: any = [];
        var week = 1;

        while (firstDate.getTime() <= lastDate.getTime()) {
            var isPast = false;
            var isToday = false;


            if (firstDate.getTime() < todayFirstTime.getTime()) {
                isPast = true;
            }

            console.log(startDate.getMonth());


            const firstDateNumber = firstDate.getFullYear() * 10000 + firstDate.getMonth() * 100 + firstDate.getDate();
            var realStartDateNumber = realStartDate.getFullYear() * 10000 + realStartDate.getMonth() * 100 + realStartDate.getDate();

            if (location === "gimpo") {
                realStartDateNumber = 20251129;
            }


            //startDate보다 이전인지 확인
            if (firstDateNumber < realStartDateNumber) {
                isPast = true;
            }

            var realEndDateData = realEndDate;

            if (location === "daechi") {
                // realEndDateData = new Date(2025, 11, 1);

                const today = new Date();

                var isThursday = false;

                var availableDateCount = 3;

                if (today.getDay() === 4) {
                    isThursday = true;
                    availableDateCount = 4;
                }

                const endDate = new Date();
                endDate.setDate(endDate.getDate() + availableDateCount);

                realEndDateData = endDate;


            }

            if (location === "gimpo") {
                realEndDateData = new Date(2025, 12, 12);
            }

            //endDate보다 이후인지 확인
            if (firstDate.getTime() > realEndDateData.getTime()) {
                isPast = true;
            }

            //일요일이면 막기
            if (firstDate.getDay() === 0) {
                isPast = true;
            }

            if (firstDate.getDate() < 7 && startDate.getMonth() === 10 && startDate.getFullYear() === 2025) {
                isPast = true;
            }

            if ((firstDate.getTime() >= todayFirstTime.getTime()) && (firstDate.getTime() <= todayLastTime.getTime())) {
                isToday = true;
            }




            const oneDay = {
                year: firstDate.getFullYear(),
                month: firstDate.getMonth(),
                date: firstDate.getDate(),
                day: firstDate.getDay(),
                week,
                isPast,
                isToday
            }
            calendarData.push(oneDay);

            if (oneDay.day === 6) {
                week++;
            }

            firstDate.setDate(firstDate.getDate() + 1);
        }

        console.log(calendarData);

        setCalendar(calendarData);
        setSelectedTime(0);

    }, [showingDate, location, startDate]);

    const monthChange = (type: string) => {
        if (type === "plus") {
            startDate.setMonth(startDate.getMonth() + 1);
            setShowingDate(startDate.getTime());
        } else if (type === "minus") {
            startDate.setMonth(startDate.getMonth() - 1);
            setShowingDate(startDate.getTime());
        }
    }

    //----------------------------------------------------------------------

    //날짜 선택하는 기능----------------------------------------------------------------------------------
    const dateClick = (year: number, month: number, date: number, day: number, isPast: boolean) => {
        if (isPast) {
            return;
        }

        // setCalendarShow(false);

        setSelectedDay(year * 10000 + month * 100 + date);
        setRealSelectedDay({ year, month, date, day });
    }
    //-----------------------------------------------------------------------------------------------------


    const typeName = (e: any) => {
        setName(e.target.value);
    }

    const typeTelephone = (e: any) => {
        console.log(e.target.value);

        if (certifyCorrect === "success") {
            console.log("already");
            return;
        }

        e.target.value = e.target.value.replace(/[^\d]+/g, "");

        if (e.target.value.length > 11) {
            return;
        }

        setTelephoneNumber(e.target.value);

        if (e.target.value.length === 11) {
            setFullTelephone(true);
            if (telephoneNumberInputRef.current) {
                telephoneNumberInputRef.current.blur();
            }
        } else {
            setFullTelephone(false);
        }
    }


    const typeCert = (e: any) => {
        console.log(e.target.value);
        e.target.value = e.target.value.replace(/[^\d]+/g, "");

        if (e.target.value.length > 6) {
            console.log(111);
            return;
        }

        // if (!certifyClicked){
        //     console.log(222);
        //     return;
        // }

        if (e.target.value.length !== 6) {
            setCertifyCorrect(null);
        }

        setCertNumber(e.target.value);

        if (e.target.value.length === 6) {

            fetch(`https://suneungsunbae.com/api/booking/cert`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    telephoneNumber,
                    certNumber: e.target.value
                })
            }).then((response: any) => {
                response.json()
                    .then((result: any) => {
                        console.log(result);
                        if (result.message !== "success") {
                            setCertifyCorrect("fail");
                        } else {
                            setCertifyCorrect("success");
                            if (certNumberInputRef.current) {
                                certNumberInputRef.current.blur();
                            }
                        }
                    })
            }
            )
        }

    }


    const getCert = (e: any, type: string) => {
        if (!fullTelephone) {
            console.log("morenumber");
            return;
        }

        if (certifyClicked && type === "btn") {
            console.log("reclick");
            return;
        }

        if (intervalId) {
            clearInterval(intervalId);
        }



        setCertifyClicked(true);
        setCertifyCorrect(null);

        certNumberInputRef.current.focus();

        var remain = 300;

        setRemainTime(300);

        intervalId = setInterval(() => {
            if (remain > -1) {
                setRemainTime(remain);
                remain--;
            }
        }, 1000);


        fetch(`https://suneungsunbae.com/api/booking/cert?telephoneNumber=${telephoneNumber}`, {
            method: "GET"
        }).then((response: any) => {
            response.json()
                .then((result: any) => {
                    console.log(result);
                })
        }
        )
    }


    const submit = () => {


        if (!name) {
            console.log("noName")
            setSubmitStatus("noName");
            return;
        }
        if (certifyCorrect !== "success") {
            console.log("noCert");
            setSubmitStatus("noCert");
            return;
        }

        const thisSelectedEndIndex = selectedEndIndex.split("_")[1];

        const endDate = select === 0
            ?
            `${preWinterData[parseInt(thisSelectedEndIndex)]?.year}-${preWinterData[parseInt(thisSelectedEndIndex)]?.month}-${preWinterData[parseInt(thisSelectedEndIndex)]?.date} 00:00:00`
            :
            `${(regularWinterData[parseInt(thisSelectedEndIndex)]?.year)}-${regularWinterData[parseInt(thisSelectedEndIndex)]?.month}-${regularWinterData[parseInt(thisSelectedEndIndex)]?.date} 00:00:00`

        const data = {
            location: location,
            select: select,
            date: `${realSelectedDay.year}-${realSelectedDay.month + 1}-${realSelectedDay.date} 00:00:00`,
            endDate: endDate,
            name: name,
            telephoneNumber: telephoneNumber,
            cert: certNumber,
            finalPrice: finalPrice.finalPrice,
        }

        if (location === "gimpo") {
            data.select = 1;
        }

        console.log(data);

        setSubmitLoading(true);

        fetch(`https://peetsunbae.com/dashboard/payments/winterschool/submit`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                data
            })
        }).then((response: any) => {
            response.json()
                .then((result: any) => {

                    setSubmitLoading(false);
                    console.log(result.message);
                    if (result.message === "fail" || result.message === "error") {
                        alert("오류 관리자 문의(010-9880-0489)")
                    }
                    if (result.message === "success") {
                        const shortURL = result.shortURL;

                        if (shortURL) {
                            console.log(shortURL);
                            window.location.href = shortURL;
                        }

                    }
                })
        })

    }

    useEffect(() => {

        if (select === 0) {

            const newPrewinterData = preWinterData;

            var defaultPrice = 790000;
            var defaultPercent = 0.95;

            if (location === "gimpo") {
                defaultPrice = 690000;
                defaultPercent = 0.9;
            }

            if (realSelectedDay.month === 10 || realSelectedDay.month === 11 || realSelectedDay.month === 0) {

                var finalPrice: any;

                if (realSelectedDay.month === 10) {

                    const date = realSelectedDay.date;
                    const dateGap = 31 - date;
                    const price11 = defaultPrice / 30 * dateGap;
                    //price11을 2자리 수 이하는 내림
                    const flooredPrice11 = Math.floor(price11 / 100) * 100;
                    const price12 = defaultPrice;

                    finalPrice = flooredPrice11 + price12;

                }

                if (realSelectedDay.month === 11) {

                    const date = realSelectedDay.date;
                    const dateGap = 32 - date;
                    const price12 = defaultPrice / 31 * dateGap;
                    const flooredPrice12 = Math.floor(price12 / 100) * 100;

                    finalPrice = flooredPrice12;
                }

                if (realSelectedDay.month === 0) {

                    const date = realSelectedDay.date;
                    const dateGap = 32 - date;
                    const price12 = defaultPrice / 31 * dateGap;
                    const flooredPrice12 = Math.floor(price12 / 100) * 100;

                    finalPrice = flooredPrice12;
                }


                const discountPrice0 = Math.floor(finalPrice * 0.95 / 100) * 100;


                newPrewinterData[0].price = finalPrice;
                newPrewinterData[0].afterPrice = discountPrice0;

                if (realSelectedDay.month !== 0) {
                    finalPrice += defaultPrice;
                }

                const discountPrice = Math.floor(finalPrice * defaultPercent / 100) * 100;

                newPrewinterData[1].price = finalPrice;
                newPrewinterData[1].afterPrice = discountPrice;

                finalPrice += defaultPrice;

                const discountPrice2 = Math.floor(finalPrice * defaultPercent / 100) * 100;

                newPrewinterData[2].price = finalPrice;
                newPrewinterData[2].afterPrice = discountPrice2;

            }

            setPreWinterData([...newPrewinterData]);
        }

    }, [select, realSelectedDay, location]);

    useEffect(() => {

        if (selectedEndIndex && selectedEndIndex.startsWith(`${select}_`)) {
            if (select === 0) {
                //프리윈터
                const index = parseInt(selectedEndIndex.split("_")[1]);
                if (preWinterData[index].discount || location === "gimpo") {
                    setFinalPrice({
                        discount: true,
                        price: preWinterData[index].price,
                        finalPrice: preWinterData[index].afterPrice ? preWinterData[index].afterPrice : 0
                    })
                } else {
                    setFinalPrice({
                        discount: false,
                        price: preWinterData[index].price,
                        finalPrice: preWinterData[index].price
                    })
                }
            } else if (select === 1) {
                //정규윈터
                const index = parseInt(selectedEndIndex.split("_")[1]);
                if (regularWinterData[index].discount || location === "gimpo") {
                    setFinalPrice({
                        discount: true,
                        price: regularWinterData[index].price,
                        finalPrice: regularWinterData[index].afterPrice ? regularWinterData[index].afterPrice : 0
                    })
                } else {
                    setFinalPrice({
                        discount: false,
                        price: regularWinterData[index].price,
                        finalPrice: regularWinterData[index].price
                    })
                }
            }
        } else {
            setFinalPrice({
                discount: false,
                price: 0,
                finalPrice: 0
            })
        }

    }, [selectedEndIndex, preWinterData, select, location]);

    const nextBtn = () => {
        setPageNumber(2);
    }

    useEffect(() => {

        if (name && certifyCorrect === "success" && telephoneNumber) {
            setDisabled2(false);
            return;
        }

        setDisabled2(true);

    }, [name, certifyCorrect, telephoneNumber]);

    //김포점 선택했을때 바껴야되는 로직
    useEffect(() => {

        if (location === "gimpo") {
            //프리윈터만 선택 가능
            if (select === 1) {
                setSelect(0);
            }

            //startDate를 2025.12.29로 변경
            const newStartDate = new Date(2025, 11, 29);
            setStartDate(newStartDate);
            setShowingDate(newStartDate.getTime());

            //selectedDay, realSelectedDay도 변경
            setSelectedDay(20251129);
            setRealSelectedDay({ year: 2025, month: 11, date: 29, day: 1 });

            if (selectedEndIndex === "0_0") {
                setSelectedEndIndex("");
            }

        }

    }, [location, select]);

    return (
        <div>
            <HeaderTwo />
            <div className={styles.voidHeader}>
            </div>

            <div className={styles.titleText}>
                1분 안에<br></br>윈터 신청 해드릴게요!
            </div>
            {/* <div className={styles.subTitleText}>
                전화나 문자로 상담 예약 원하시면<br></br>050-7871-3574로 연락주세요.(24시 가능)
            </div> */}

            <div className={styles.formBody}>
                {
                    pageNumber === 1
                        ?
                        <>
                            <div className={`${styles.questionText} ${styles.first}`}>
                                어느 지점에 등록을 원하시나요?
                            </div>
                            <div className={styles.selectDiv}>
                                <div onClick={(e: any) => { setLocation("gangnam"); }} className={`${styles.select} ${location === "gangnam" ? styles.active : ""}`}>
                                    강남점
                                </div>
                                <div onClick={(e: any) => { setLocation("daechi"); }} className={`${styles.select} ${location === "daechi" ? styles.active : ""}`}>
                                    대치점
                                </div>
                            </div>
                            <div className={styles.selectDiv} style={{
                                marginTop: "10px"
                            }}>
                                <div onClick={(e: any) => { setLocation("bundang"); }} className={`${styles.select} ${location === "bundang" ? styles.active : ""}`}>
                                    분당점
                                </div>
                                <div onClick={(e: any) => { setLocation("songpa"); }} className={`${styles.select} ${location === "songpa" ? styles.active : ""}`}>
                                    송파점
                                </div>
                            </div>
                            <div className={styles.selectDiv} style={{
                                marginTop: "10px"
                            }}>
                                <div onClick={(e: any) => { setLocation("gimpo"); }} className={`${styles.select} ${location === "gimpo" ? styles.active : ""}`}>
                                    김포점 (12월 29일 오픈)
                                </div>
                                <div onClick={(e: any) => { return; setLocation("sinchon"); }} className={`${styles.select} ${location === "sinchon" ? styles.active : ""}`}>
                                    신촌점 (오픈 예정)
                                </div>
                            </div>

                            <div className={`${styles.questionText} ${styles.first}`}>
                                입실은 언제 원하시나요?
                            </div>
                            <div className={styles.selectDiv}>
                                <div onClick={(e: any) => {
                                    setSelect(0);
                                }} className={`${styles.select} ${select === 0 ? styles.active : ""}`}>
                                    {location !== "gimpo" ? `프리윈터 (방학 이전)` : "정규 윈터 (방학 이후)"}
                                </div>
                                {
                                    location !== "gimpo"
                                        ?
                                        <div onClick={(e: any) => { setSelect(1); }} className={`${styles.select} ${select === 1 ? styles.active : ""}`}>
                                            정규윈터 (방학 이후)
                                        </div>
                                        :
                                        ""
                                }

                                {/* <div onClick={(e: any) => { setSelect(2); }} className={`${styles.select} ${select === 2 ? styles.active : ""} ${styles.last}`}>
                        시설 구경
                    </div> */}
                            </div>



                            <div className={`${styles.questionText} ${styles.second}`}>
                                등록기간을 선택해주세요
                            </div>

                            <div className={styles.periodDiv}>
                                <div className={styles.periodBox} onClick={() => { setCalendarShow(!calendarShow); }}>
                                    <div className={styles.periodTitle}>
                                        등원일{select === 1 ? " (날짜 변경 불가)" : ""}
                                    </div>
                                    <div className={styles.periodChoice}>
                                        {realSelectedDay ? `${realSelectedDay.year}.${realSelectedDay.month + 1}.${realSelectedDay.date}` : "선택"}
                                        {!realSelectedDay ? <ChevronRight className={styles.periodChevron} /> : null}
                                    </div>
                                </div>

                                {
                                    (calendarShow && select === 0)
                                        ?
                                        <div className={styles.calendarBox}>
                                            <div className={styles.calendarWrap}>
                                                <div className={styles.firstRow}>
                                                    <Button sx={{ width: "auto", padding: "0px", minWidth: "0px", paddingRight: "10px" }} disabled={minusMonthDisable} onClick={(e: any) => { monthChange("minus") }}>
                                                        <ChevronLeft className={styles.left} fill={minusMonthDisable ? "#dedede" : "black"} />
                                                    </Button>
                                                    <div className={styles.month}>
                                                        {year && year}년 {(month || month === 0) && month + 1}월
                                                    </div>
                                                    <Button sx={{ width: "auto", padding: "0px", minWidth: "0px", paddingLeft: "10px" }} onClick={(e: any) => { monthChange("plus") }}>
                                                        <ChevronRight className={styles.right} />
                                                    </Button>
                                                </div>
                                                <div className={styles.row}>
                                                    <div ref={(element) => { eachRef.current.push(element) }} className={`${styles.day}`}>
                                                        일
                                                    </div>
                                                    <div ref={(element) => { eachRef.current.push(element) }} className={`${styles.day}`}>
                                                        월
                                                    </div>
                                                    <div ref={(element) => { eachRef.current.push(element) }} className={`${styles.day}`}>
                                                        화
                                                    </div>
                                                    <div ref={(element) => { eachRef.current.push(element) }} className={`${styles.day}`}>
                                                        수
                                                    </div>
                                                    <div ref={(element) => { eachRef.current.push(element) }} className={`${styles.day}`}>
                                                        목
                                                    </div>
                                                    <div ref={(element) => { eachRef.current.push(element) }} className={`${styles.day}`}>
                                                        금
                                                    </div>
                                                    <div ref={(element) => { eachRef.current.push(element) }} className={`${styles.day}`}>
                                                        토
                                                    </div>
                                                </div>
                                                {
                                                    weeks && weeks.map((eachWeek: number) => {
                                                        return (
                                                            <div key={eachWeek} className={styles.row}>
                                                                {
                                                                    calendar && calendar.map((eachDay: any) => {
                                                                        if (eachWeek === eachDay.week) {
                                                                            return (
                                                                                <div key={eachDay.month * 100 + eachDay.date} ref={(element) => { eachRef.current.push(element) }} onClick={(e: any) => { dateClick(eachDay.year, eachDay.month, eachDay.date, eachDay.day, eachDay.isPast) }} className={`${styles.date} ${eachDay.day === 0 ? styles.sunday : ""} ${eachDay.isToday ? styles.todayDate : ""} ${eachDay.isPast ? styles.pastDate : ""} ${eachDay.day === 6 ? styles.saturday : ""} ${selectedDay === eachDay.year * 10000 + eachDay.month * 100 + eachDay.date ? styles.active : ""}`}>
                                                                                    <div className={styles.eachDate}>
                                                                                        {eachDay.date}
                                                                                    </div>
                                                                                    {/* <div className={`${eachDay.isToday ? styles.today : styles.none}`}>
                                                                    오늘
                                                                </div> */}
                                                                                </div>
                                                                            );
                                                                        }
                                                                    })
                                                                }
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                        :
                                        ""
                                }



                                <div className={styles.periodBox} style={{ marginTop: "10px" }}
                                    onClick={() => { setEndDateShow(!endDateShow); }}
                                >
                                    <div className={styles.periodTitle}>
                                        결제기간
                                    </div>
                                    <div className={styles.periodChoice}>
                                        {selectedEndIndex && selectedEndIndex.startsWith(`${select}_`) ?
                                            select === 0 ? preWinterData[parseInt(selectedEndIndex.split("_")[1])].dateString : regularWinterData[parseInt(selectedEndIndex.split("_")[1])].dateString
                                            : "선택"}
                                        {
                                            (selectedEndIndex && selectedEndIndex.startsWith(`${select}_`))
                                                ?
                                                ""
                                                :
                                                <ChevronRight className={styles.periodChevron} />
                                        }

                                    </div>
                                </div>

                                {
                                    endDateShow
                                        ?
                                        <div className={styles.periodEndBox}>
                                            <div className={`${styles.eachEndDiv} ${styles.location}`}>
                                                <div className={`${styles.eachEndDivStart} ${styles.location}`}>
                                                    {
                                                        location === "gangnam" ? "강남점" :
                                                            location === "daechi" ? "대치점" :
                                                                location === "bundang" ? "분당점" :
                                                                    location === "songpa" ? "송파점" :
                                                                        location === "gimpo" ? "김포점" :
                                                                            location === "sinchon" ? "신촌점" :
                                                                                "지점"
                                                    }
                                                </div>
                                                <div className={`${styles.eachEndDivEnd} ${styles.location}`}>
                                                    {
                                                        location ? price[location as keyof typeof price] : price.default
                                                    }
                                                </div>
                                            </div>
                                            {
                                                (select === 0 ? preWinterData : regularWinterData).map((eachData: any, index: number) => {

                                                    if (location === "gimpo" && select === 0) {
                                                        if (index === 0) {
                                                            return;
                                                        }
                                                    }

                                                    return (
                                                        <div className={`${styles.eachEndDiv} ${styles[`eachEndDiv${index}`]} ${selectedEndIndex === `${select}_${index}` ? styles.active : ""}`}
                                                            onClick={() => {
                                                                setSelectedEndIndex(`${select}_${index}`);
                                                                setEndDateShow(false);
                                                                setCalendarShow(false);
                                                            }}
                                                        >
                                                            <div className={styles.eachEndDivStart}>
                                                                <div className={`${styles.eachEndDivDate} ${selectedEndIndex === `${select}_${index}` ? styles.active : ""}`}>
                                                                    {realSelectedDay.year}.{realSelectedDay.month + 1}.{realSelectedDay.date}부터 {eachData.dateString}
                                                                </div>
                                                                <div className={styles.eachEndDivPrice}>
                                                                    {
                                                                        (eachData.discount || location === "gimpo") ?
                                                                            <div className={styles.beforeDiscount}>
                                                                                <span className={styles.beforeDiscountPercent}>{location !== "gimpo" ? "5%" : "10%"}</span><span className={styles.beforeDiscountPrice}>
                                                                                    {eachData.price.toLocaleString()}
                                                                                </span>
                                                                            </div>
                                                                            :
                                                                            ""
                                                                    }
                                                                    {(eachData.discount || location === "gimpo") ?
                                                                        eachData.afterPrice.toLocaleString()
                                                                        :
                                                                        eachData.price.toLocaleString()}
                                                                    원
                                                                </div>
                                                            </div>
                                                            <div className={styles.eachEndDivEnd}>
                                                                <ChevronRight className={styles.endChevron} />
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        :
                                        ""
                                }

                            </div>

                            {
                                (realSelectedDay && (selectedEndIndex && selectedEndIndex.startsWith(`${select}_`)))
                                    ?
                                    <>
                                        <div className={`${styles.questionText} ${styles.second}`}>
                                            아래 내용이 맞는지 확인해주세요
                                        </div>
                                        <div className={styles.descriptionBox}>
                                            <div className={styles.descriptionBoxTitle}>
                                                {(select === 0 && location !== "gimpo") ? "프리윈터" : "정규윈터"}
                                            </div>
                                            <div className={styles.desciptionBoxText} style={{
                                                marginBottom: "30px"
                                            }}>
                                                <div className={styles.descriptionBoxTextItem1}>
                                                    지점
                                                </div>
                                                <div className={styles.descriptionBoxTextItem2}>
                                                    {
                                                        location === "gangnam" ? "강남점" :
                                                            location === "daechi" ? "대치점" :
                                                                location === "bundang" ? "분당점" :
                                                                    location === "songpa" ? "송파점" :
                                                                        location === "gimpo" ? "김포점" :
                                                                            location === "sinchon" ? "신촌점" :
                                                                                ""
                                                    }
                                                </div>
                                            </div>
                                            <div className={styles.desciptionBoxText}>
                                                <div className={styles.descriptionBoxTextItem1}>
                                                    일정
                                                </div>
                                                <div className={styles.descriptionBoxTextItem2}>
                                                    {
                                                        `
                                ${realSelectedDay.year}.${realSelectedDay.month + 1}.${realSelectedDay.date} (${weekString[realSelectedDay.day]})
                                ~
                                 ${select === 0 ? `${preWinterData[parseInt(selectedEndIndex.split("_")[1])]?.dateString} (${weekString[new Date(preWinterData[parseInt(selectedEndIndex.split("_")[1])]?.year, preWinterData[parseInt(selectedEndIndex.split("_")[1])]?.month - 1, preWinterData[parseInt(selectedEndIndex.split("_")[1])]?.date).getDay()]})` : `${regularWinterData[parseInt(selectedEndIndex.split("_")[1])]?.dateString} (${weekString[new Date(regularWinterData[parseInt(selectedEndIndex.split("_")[1])]?.year, regularWinterData[parseInt(selectedEndIndex.split("_")[1])]?.month - 1, regularWinterData[parseInt(selectedEndIndex.split("_")[1])]?.date).getDay()]})`
                                                        } 
                                `
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className={styles.resultBox}>
                                            <div className={styles.resultBoxTitle}>
                                                총액
                                            </div>
                                            <div className={styles.resultBoxPriceDiv}>
                                                {
                                                    (finalPrice.discount || location === "gimpo")
                                                        ?
                                                        <div className={styles.resultBoxPercent}>
                                                            {location !== "gimpo" ? "5%" : "10%"}
                                                        </div>
                                                        :
                                                        ""
                                                }
                                                {
                                                    (finalPrice.discount || location === "gimpo")
                                                        ?
                                                        <div className={styles.resultBoxPrePrice}>
                                                            {finalPrice.price.toLocaleString()}원
                                                        </div>
                                                        :
                                                        ""
                                                }
                                                <div className={styles.resultBoxFinalPrice}>
                                                    {finalPrice.finalPrice.toLocaleString()}원
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <div style={{ height: "42px" }}>

                                    </div>
                            }
                        </>
                        :
                        ""
                }

                {
                    pageNumber === 2
                        ?
                        <>
                            <div className={`${styles.questionText} ${styles.third}`}>
                                간단한 정보만 적어주세요
                            </div>

                            <div className={styles.inputWrapper}>
                                <div className={styles.inputDiv}>
                                    <input value={name} onChange={typeName} placeholder="이름을 적어주세요" className={styles.input} type="text">

                                    </input>
                                </div>
                                <div className={styles.telephoneDiv}>
                                    <div className={styles.telephoneInputDiv}>
                                        <input ref={telephoneNumberInputRef} pattern="\d*" value={telephoneNumber} onChange={typeTelephone} placeholder="핸드폰번호를 적어주세요" className={styles.telephoneInput} type="tel">

                                        </input>
                                    </div>
                                    <div className={styles.telephoneBtnDiv}>
                                        <div onClick={(e: any) => { getCert(e, "btn") }} className={`${styles.certBtn} ${(fullTelephone && !certifyClicked) ? styles.active : ""}`}>
                                            {
                                                !certifyClicked &&
                                                <span className={styles.btnText}>
                                                    인증번호 받기
                                                </span>
                                            }
                                            {
                                                (certifyClicked) &&
                                                <span className={styles.btnText}>
                                                    0
                                                    {Math.floor(remainTime / 60)}
                                                    :
                                                    {
                                                        remainTime % 60 < 10 ?
                                                            "0" + remainTime % 60 : remainTime % 60
                                                    }
                                                </span>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.inputDiv} ${styles.cert}`}>
                                    <input ref={certNumberInputRef} pattern="\d*" value={certNumber} onChange={typeCert} placeholder="인증번호를 입력해주세요" className={styles.input} type="tel">

                                    </input>
                                </div>
                                <div className={styles.certText}>
                                    {
                                        (certifyClicked && !certifyCorrect) &&
                                        <>
                                            인증번호가 발송되었습니다 <span className={styles.recert} onClick={(e: any) => { getCert(e, "rebtn") }}>&nbsp;&nbsp;&nbsp;&nbsp;재전송하기</span>
                                        </>
                                    }
                                    {
                                        (certifyClicked && certifyCorrect === "fail") &&
                                        <>
                                            <span className={styles.certifyFail}>
                                                잘못된 인증번호입니다.
                                            </span>
                                            <span className={styles.recert2} onClick={(e: any) => { getCert(e, "rebtn") }}>&nbsp;&nbsp;&nbsp;&nbsp;재전송하기</span>
                                        </>
                                    }
                                    {
                                        (certifyClicked && certifyCorrect === "success") &&
                                        <>
                                            <span className={styles.certifySuccess}>
                                                핸드폰인증에 성공했습니다.
                                            </span>
                                        </>
                                    }
                                </div>
                            </div>
                            {/* <div className={styles.informResult}>
                                {
                                    submitStatus === "noTime" &&
                                    <span className={styles.informResult}>
                                        시간을 선택해주세요
                                    </span>
                                }
                                {
                                    submitStatus === "noName" &&
                                    <span className={styles.informResult}>
                                        이름을 입력해주세요
                                    </span>
                                }
                                {
                                    submitStatus === "noCert" &&
                                    <span className={styles.informResult}>
                                        핸드폰 인증을 해주세요
                                    </span>
                                }
                            </div> */}

                            {
                                (realSelectedDay && (selectedEndIndex && selectedEndIndex.startsWith(`${select}_`)))
                                    ?
                                    <>
                                        <div className={`${styles.questionText} ${styles.second}`}>
                                            아래 내용이 맞는지 확인해주세요
                                        </div>
                                        <div className={styles.descriptionBox}>
                                            <div className={styles.descriptionBoxTitle}>
                                                {(select === 0 && location !== "gimpo") ? "프리윈터" : "정규윈터"}
                                                <div className={styles.descriptionBoxEditBtn}
                                                    onClick={() => {
                                                        setPageNumber(1);
                                                    }}
                                                >
                                                    변경
                                                </div>
                                            </div>
                                            <div className={styles.desciptionBoxText} style={{
                                                marginBottom: "30px"
                                            }}>
                                                <div className={styles.descriptionBoxTextItem1}>
                                                    지점
                                                </div>
                                                <div className={styles.descriptionBoxTextItem2}>
                                                    {
                                                        location === "gangnam" ? "강남점" :
                                                            location === "daechi" ? "대치점" :
                                                                location === "bundang" ? "분당점" :
                                                                    location === "songpa" ? "송파점" :
                                                                        location === "gimpo" ? "김포점" :
                                                                            location === "sinchon" ? "신촌점" :
                                                                                ""
                                                    }
                                                </div>
                                            </div>
                                            <div className={styles.desciptionBoxText}>
                                                <div className={styles.descriptionBoxTextItem1}>
                                                    일정
                                                </div>
                                                <div className={styles.descriptionBoxTextItem2}>
                                                    {
                                                        `
                                ${realSelectedDay.year}.${realSelectedDay.month + 1}.${realSelectedDay.date} (${weekString[realSelectedDay.day]})
                                ~
                                 ${select === 0 ? `${preWinterData[parseInt(selectedEndIndex.split("_")[1])]?.dateString} (${weekString[new Date(preWinterData[parseInt(selectedEndIndex.split("_")[1])]?.year, preWinterData[parseInt(selectedEndIndex.split("_")[1])]?.month - 1, preWinterData[parseInt(selectedEndIndex.split("_")[1])]?.date).getDay()]})` : `${regularWinterData[parseInt(selectedEndIndex.split("_")[1])]?.dateString} (${weekString[new Date(regularWinterData[parseInt(selectedEndIndex.split("_")[1])]?.year, regularWinterData[parseInt(selectedEndIndex.split("_")[1])]?.month - 1, regularWinterData[parseInt(selectedEndIndex.split("_")[1])]?.date).getDay()]})`
                                                        } 
                                `
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className={styles.resultBox}>
                                            <div className={styles.resultBoxTitle}>
                                                총액
                                            </div>
                                            <div className={styles.resultBoxPriceDiv}>
                                                {
                                                    finalPrice.discount
                                                        ?
                                                        <div className={styles.resultBoxPercent}>
                                                            {location !== "gimpo" ? "5%" : "10%"}
                                                        </div>
                                                        :
                                                        ""
                                                }
                                                {
                                                    finalPrice.discount
                                                        ?
                                                        <div className={styles.resultBoxPrePrice}>
                                                            {finalPrice.price.toLocaleString()}원
                                                        </div>
                                                        :
                                                        ""
                                                }
                                                <div className={styles.resultBoxFinalPrice}>
                                                    {finalPrice.finalPrice.toLocaleString()}원
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <div style={{ height: "42px" }}>

                                    </div>
                            }
                        </>
                        :
                        ""
                }






                {
                    pageNumber === 1
                        ?
                        <div className={styles.submitBtnDiv} style={{
                            marginTop: "0px"
                        }}>
                            {
                                props.test
                                    ?
                                    <Button onClick={nextBtn} variant="contained" fullWidth sx={{ height: "72px", borderRadius: "12px", backgroundColor: "#3c3c3c", color: "white", fontWeight: 700, fontSize: "20px", "&:hover": { backgroundColor: "rgb(100,100,100)" }, "@media (max-width : 1024px)": { fontSize: "16px", height: '55.5px' } }}
                                        disabled={!(realSelectedDay && (selectedEndIndex && selectedEndIndex.startsWith(`${select}_`)))}
                                    // disabled={true}
                                    >
                                        {/* 10월 20일 월요일 20시 오픈 */}
                                        다음
                                    </Button>
                                    :
                                    <Button onClick={nextBtn} variant="contained" fullWidth sx={{ height: "72px", borderRadius: "12px", backgroundColor: "#3c3c3c", color: "white", fontWeight: 700, fontSize: "20px", "&:hover": { backgroundColor: "rgb(100,100,100)" }, "@media (max-width : 1024px)": { fontSize: "16px", height: '55.5px' } }}
                                        // disabled={!(realSelectedDay && (selectedEndIndex && selectedEndIndex.startsWith(`${select}_`)))}
                                        disabled={true}
                                    >
                                        10월 20일 월요일 20시 오픈
                                    </Button>
                            }
                        </div>
                        :
                        <div className={styles.submitBtnDiv} style={{
                            marginTop: "0px"
                        }}>
                            <Button
                                disabled={disabled2 || submitLoading} onClick={submit} variant="contained" fullWidth sx={{ height: "72px", borderRadius: "12px", backgroundColor: "#3c3c3c", color: "white", fontWeight: 700, fontSize: "20px", "&:hover": { backgroundColor: "rgb(100,100,100)" }, "@media (max-width : 1024px)": { fontSize: "16px", height: '55.5px' } }}
                            >
                                {
                                    submitLoading ?
                                        <span style={{
                                            color: "white"
                                        }}>
                                            <CircularProgress size={32} color="inherit" />
                                        </span>
                                        :
                                        <span>결제하기</span>
                                }
                            </Button>
                        </div>
                }



                {/* <div className={styles.bottomText}>
                    ※ 예약 내역을 카카오 알림톡으로 전송해드립니다
                </div> */}

                {
                    location === "gimpo"
                        ?
                        <div className={styles.bottomBanner} style={{
                            display: bannerVisible ? "flex" : "none"
                        }}>
                            <div className={styles.bottomBannerText}>
                                {
                                    location !== "gimpo"
                                        ?
                                        "사전등록 혜택"
                                        :
                                        "오픈 이벤트"
                                }

                            </div>
                            <div className={styles.bottomBannerDescription}>
                                {
                                    location !== "gimpo"
                                        ?
                                        "2025년 12월 4일 이전 결제시, 결제 금액의 5% 할인 적용"
                                        :
                                        "2025년 12월 31일 이전 결제시, 결제 금액의 10% 할인 적용"
                                }

                            </div>
                        </div>
                        :
                        ""
                }

            </div>

            <div className={styles.void}>

            </div>



            {/* <SpeedDialComponent /> */}
            <div ref={footerRef}>
                <Footer />
            </div>

        </div>
    )
}

export default RegisterFor2026Winter;